<app-shared-navbar
  [brandRoute]="'/'"
  [siteName]="sitename"
  [menuItems]="menuItems"
  [profileMenuItems]="profileMenuItems"
  [avatarSrc]="imageSrc || avatarUrl"
  [showNotifications]="notificationConfig.show"
  [notificationPermission]="notificationConfig.permission"
  [navbarClass]="'navbar navbar-expand-lg fixed-top'"
  (itemSelected)="onNavbarAction($event)">
</app-shared-navbar>

<!-- Site Edit Status Dialog -->
<ng-template #siteEditStatusDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title">INFO</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p><i class="fa fa-info-circle" aria-hidden="true"></i> &nbsp; Site Settings saving under progress, please try after its completed</p>
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary" (click)="navigateToHome(modal)">Home</button> -->
  </div>
</ng-template>
